import { useEffect } from "react";
import { DEFAULT_DESCRIPTION, SITE_NAME, SITE_URL } from "../data/site.js";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.rel = "canonical";
    document.head.appendChild(el);
  }
  el.href = href;
}

/* Per-route <title>, description, canonical and social tags. `title` is the page's own name;
   leave it out for the home page. `noindex` keeps pages like the 404 out of search results. */
export default function useDocumentMeta({ title, description = DEFAULT_DESCRIPTION, path = "/", noindex = false } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
    const url = `${SITE_URL}${path}`;
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "robots", noindex ? "noindex" : "index, follow");
    setCanonical(url);
  }, [title, description, path, noindex]);
}
